import React from "react";

const TextareaField = ({
  label,
  name,
  value = "",
  customClass = "",
  onChange,
  ...rest
}) => (
  <div className="space-y-2">
    {label ? (
      <label
        className="block text-sm font-medium uppercase tracking-[0.2em] text-skin-accentSoft"
        htmlFor={name}
      >
        {label}
      </label>
    ) : null}
    <textarea
      id={name}
      name={name}
      className={`w-full rounded-2xl border border-white/15 bg-white/10 px-4 py-4 text-sm text-skin-text outline-none transition placeholder:text-skin-muted focus:border-[var(--accent)] focus:bg-white/15 ${customClass}`}
      onChange={onChange}
      value={value}
      {...rest}
    />
  </div>
);

export default TextareaField;
